import { EventDrivenStore } from '@core/store/eventDrivenStore';

class DashboardStore extends EventDrivenStore {
  constructor() {
    super('dashboard', {
      stats: {
        totalTransactions: 0,
        totalSpent: 0,
        activeSubscriptions: 0,
        pendingTransactions: 0,
      },
      loading: false,
      error: null,
    });
  }

  // Load dashboard stats
  async loadStats() {
    this.state.loading = true;
    this.state.error = null;

    try {
      // Emit event to trigger API call via controller
      this.emit('dashboard.refresh');
    } catch (error) {
      this.state.error = error.message;
      console.error('Error loading dashboard stats:', error);
      this.state.loading = false;
    }
  }

  // Get stats
  getStats() {
    return this.state.stats;
  }
}

export default DashboardStore;
